import { Box, Typography, Grid, Card } from '@mui/material'
import type { FC } from 'react'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import { type ReferralSearchPersonAvailabilityCreateResponse } from '@fireflyhealth/api'

interface SearchAvailableProps {
  searchAvailability: ReferralSearchPersonAvailabilityCreateResponse | null | undefined
}

export const SearchNotAvailable: FC<SearchAvailableProps> = props => {
  return (
    <Card sx={{ bgcolor: 'tones.warning.bg' }}>
      <Box sx={{ p: 2 }}>
        <Grid container spacing={2} sx={{ alignItems: 'center' }}>
          <Grid>
            <Box sx={{ color: 'warning.main' }}>
              <ReportProblemOutlinedIcon color="inherit" />
            </Box>
          </Grid>
          <Grid>
            <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'brown.main' }}>
              Search not available
            </Typography>
            <Typography variant="body1" sx={{ color: 'brown.main' }}>
              {props.searchAvailability?.error}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Card>
  )
}
